import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { familyTreesAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';
import { MainLayout } from '../components';
import { useAppNavigation } from '../contexts/AppNavigationContext';

export const AuthLandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { clearNavigationState } = useAppNavigation();

  useEffect(() => {
    clearNavigationState();
  }, [clearNavigationState]);

  useEffect(() => {
    let isCancelled = false;

    const resolveLandingPage = async () => {
      if (!user?.lastOpenedTreeId) {
        navigate('/trees', { replace: true });
        return;
      }

      try {
        const [ownedRes, sharedRes] = await Promise.all([
          familyTreesAPI.getOwnedTrees(),
          familyTreesAPI.getSharedTrees(),
        ]);

        if (isCancelled) {
          return;
        }

        const owned = ownedRes.data.data || [];
        const shared = sharedRes.data.data || [];
        const allTrees = [...owned, ...shared];
        const lastOpenedTree = allTrees.find((tree) => tree.id === user.lastOpenedTreeId);

        if (lastOpenedTree) {
          navigate(`/canvas/${lastOpenedTree.id}`, { replace: true });
          return;
        }

        navigate('/trees', {
          replace: true,
          state: {
            infoMessage: 'Your last opened tree is no longer available. Showing My Trees instead.',
          },
        });
      } catch (error) {
        if (!isCancelled) {
          navigate('/trees', { replace: true });
        }
      }
    };

    resolveLandingPage();

    return () => {
      isCancelled = true;
    };
  }, [navigate, user]);

  return (
    <MainLayout>
      <div className="flex items-center justify-center min-h-[40vh]">
        <p className="text-lg text-gray-600 dark:text-gray-400">Loading...</p>
      </div>
    </MainLayout>
  );
};
